export function getMedian(values) {
    if (values.length === 0) 
        return 0;
    
    values
        .sort(function (a, b) {
            return a - b;
        });

    var half = Math.floor(values.length / 2);

    if (values.length % 2) 
        return values[half];
    
    return (values[half - 1] + values[half]) / 2.0;
}

export function isWechat() {
    if (window.location.href.toString().includes("localhost:") || (window.location.href.toString().includes("the-oaks"))) return true;
    var ua = navigator
        .userAgent
        .toLowerCase();
    if (ua.includes("micromessenger")) {
        return true;
    } else {
        return false;
    }
}

export function isRealWechat() {
    var ua = navigator
        .userAgent
        .toLowerCase();
    if (ua.includes("micromessenger")) {
        return true;
    } else {
        return false;
    }
}

export function isAndorid() {
    var u = navigator.userAgent;
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        return true;
    }
}

export function getBase64Image(img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
}

export function debugPrint(string) {
    console.log(string);
    return (string.substring(0, 75));
}

export function absorbEvent(event) {
    event.returnValue = false;
}